import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export interface PaperProps {
    className?: string;
    shadow?: number;
    outline?: boolean;
    square?: boolean;
    children?: any;
    [x: string]: any;
}

export const Paper = ({
    className,
    shadow = 1,
    outline = false,
    square = false,
    children,
    ...props
}: PaperProps) => {
    var cn = classNames("paper", className, outline, {
        [`shadow-${shadow}`]: !outline && shadow >= 0 && shadow <= 24,
        "paper-outline": outline,
        "paper-rounded": !square,
    });
    return (
        <div className={cn} {...props}>
            {children}
        </div>
    );
};

/*
Paper.propTypes = {
    className: PropTypes.string,
    shadow: PropTypes.number,
    outline: PropTypes.bool,
    square: PropTypes.bool,
};*/
